import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { isAuthenticated, verifySession } from "./index";

// Wraps a gated page and actively re-verifies the server session so an expired
// cookie forces the user to /signin — even if they were just sitting on the
// page. Checks on route entry and whenever the tab regains focus/visibility.
const SessionGuard = ({ pathname, children }) => {
    useEffect(() => {
        verifySession();

        const onFocus = () => verifySession();
        const onVisibility = () => {
            if (document.visibilityState === "visible") verifySession();
        };

        window.addEventListener("focus", onFocus);
        document.addEventListener("visibilitychange", onVisibility);
        return () => {
            window.removeEventListener("focus", onFocus);
            document.removeEventListener("visibilitychange", onVisibility);
        };
    }, [pathname]);

    return children;
};

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props => {
            const auth = isAuthenticated();
            if (!auth) {
                return (
                    <Redirect
                        to={{
                            pathname: "/signin",
                            state: { from: props.location }
                        }}
                    />
                );
            }
            if (auth.mustChangePassword && props.location.pathname !== "/change-password") {
                return <Redirect to="/change-password" />;
            }
            return (
                <SessionGuard pathname={props.location.pathname}>
                    <Component {...props} />
                </SessionGuard>
            );
        }}
    />
);

export default PrivateRoute;
